export default __webpack_public_path__ + "static/media/Highlord's Great Shield.e55ffb61.jpg";